module.exports = __webpack_public_path__ + "media/newstyle/images/card-icon-3-704801dd903ec10c5717616f7b4b095a.svg";